module.exports = __webpack_public_path__ + "media/images/libro-reclamaciones-cbdca21d940065d61ebb665bad887146.png";